import { Box, Grid2, TextField } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import style from "../../Subject/AddUpdateSubject/DataCorrection/SubmitDataCorrection/SubmitDataCorrection.module.css";
import { useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import DataCorrectionSubmitGrid from "../../../components/DataCorrectionSubmitGrid/DataCorrectionSubmitGrid";
import {
  formatDateWithoutTimeTwo,
  formatNormalDateIntoDateStr,
  notifyError,
  notifySuccess,
} from "../../../utilities/helper";
import {
  getDataCorrectionDetailsService,
  getDataOnLoadForDataCorrectionService,
  saveApprovalRejectionDataService,
} from "../../../services/dataCorrectionsService";
import DoneIcon from "@mui/icons-material/Done";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import * as yup from "yup";
import DataCorrectionConfirmation from "../../Subject/AddUpdateSubject/DataCorrection/DataCorrectionConfirmation/DataCorrectionConfirmation";
import useNavigationGuard from "../../../hooks/useNavigationGuard";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";

const correctionActionIds = {
  Approved: "e0b99bcb-0f09-4a65-a06d-7e48f5c41808",
  Rejected: "0ef32937-fe9f-4d97-b345-701080f0cfae",
  NeedsMoreInformation: "70da4cc0-ace7-45f1-bf8a-db720131a601",
  Pending: "d3c17321-c013-4d9d-8639-e2e9ccfa6adf",
};

const ApproveRejectDataCorrections = () => {
  const id = useLocation()?.state?.id;
  const access_token = localStorage.getItem("access_token");
  const cultureCode = localStorage.getItem("currentUserCultureCode");
  const email = localStorage.getItem("email");
  const userId = localStorage.getItem("roleId");

  const navigate = useNavigate();
  const [correctionTableData, setCorrectionTableData] = useState([]);
  const [load, setLoad] = useState(false);
  const [loadData, setLoadData] = useState({
    siteName: "",
    subjectName: "",
    correctionCreatedBy: "",
    reasonForCorrection: "",
    correctionCreatedOn: "",
    correctionId: "",
    correctionActionId: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [discussionData, setDiscussionData] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isRemovedSubject, setIsRemovedSubject] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [payload, setPayload] = useState(null);

  const {
    correctionCreatedBy,
    reasonForCorrection,
    siteName,
    subjectName,
    correctionCreatedOn,
    correctionId,
    correctionActionId,
  } = loadData;

  const dataCorrectionSchema = yup.object().shape({
    notes: yup.string().required("Notes is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(dataCorrectionSchema),
    defaultValues: {
      notes: "",
    },
  });

  useNavigationGuard(isDirty);

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();

  useEffect(() => {
    if (access_token && id) {
      getOnLoadData();
    }
  }, [id]);

  useEffect(() => {
    if (access_token && correctionId) {
      getOnLoadWorkFlow();
    }
  }, [correctionId]);

  // This is for enablindg disabling the buttons
  useEffect(() => {
    if (
      correctionActionId !== "" &&
      payload?.correctionDiscussions &&
      payload?.correctionDiscussions?.length > 0
    ) {
      if (
        correctionActionId === correctionActionIds.Approved ||
        correctionActionId === correctionActionIds.Rejected
      ) {
        let isDisabledFlag = false;
        payload?.correctionDiscussions?.forEach((item) => {
          if (
            (item?.correctionActionId === correctionActionIds.Approved ||
              item?.correctionActionId === correctionActionIds.Rejected) &&
            item?.studyUserId === userId
          ) {
            isDisabledFlag = true;
          }
        });
        setIsDisabled(isDisabledFlag);
      } else {
        setIsDisabled(false);
      }
    } else {
      setIsDisabled(false);
    }
  }, [correctionActionId]);

  const getOnLoadWorkFlow = async () => {
    try {
      // setLoad(true);
      const res = await getDataCorrectionDetailsService(
        correctionId,
        access_token,
        cultureCode,
      );
      if (res?.data?.status === "Success" && res?.data?.result) {
        const data = res?.data?.result?.correction?.correctionDiscussions;
        const correctionActionId =
          res?.data?.result?.correction?.correctionDiscussions[
            res?.data?.result?.correction?.correctionDiscussions?.length - 1
          ]?.correctionActionId;
        setDiscussionData(groupDiscussionData(data));
        setLoadData((prev) => ({
          ...prev,
          correctionActionId: correctionActionId,
        }));
      }
    } catch (err) {
      console.log("Error: ", err?.messsage);
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    } finally {
      // setLoad(false);
    }
  };

  const getOnLoadData = async () => {
    try {
      setLoad(true);
      const res = await getDataOnLoadForDataCorrectionService(
        access_token,
        id,
        cultureCode,
        userId,
      );
      if (res?.data?.status === "Success" && res?.data?.result) {
        const data = res?.data?.result?.correction;
        setPayload(data);
        setLoadData({
          siteName: data?.siteName,
          subjectName: data?.patient?.patientNumber,
          correctionCreatedBy: data?.startedByUser?.email,
          correctionCreatedOn: data?.startedDate,
          reasonForCorrection: data?.reasonForCorrection,
          correctionId: data?.id,
        });
        setCorrectionTableData(
          data?.correctionApprovalData?.map((item) => {
            return {
              fieldName: item?.columnName,
              currentValue: item?.oldDisplayValue,
              requestedValue: item?.newDisplayValue,
              removeValue: item?.removeItem,
            };
          }),
        );
      }
    } catch (err) {
      console.log("Error: ", err?.messsage);
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  const saveDataCorrectionAction = async (data) => {
    const newPayload = {
      id: payload?.id,
      dataCorrectionNumber: payload?.dataCorrectionNumber,
      visitName: "",
      visitId: payload?.diaryEntry?.visitId,
      patientId: payload?.patientId,
      siteId: payload?.siteId,
      patientNumber: payload?.patient?.patientNumber,
      correctionApprovalData: payload?.correctionApprovalData,
    };

    const selectedActionId =
      selectedStatus === "approve"
        ? correctionActionIds.Approved
        : selectedStatus === "reject"
          ? correctionActionIds.Rejected
          : correctionActionIds.NeedsMoreInformation;

    try {
      setLoad(true);
      const res = await saveApprovalRejectionDataService(
        access_token,
        selectedStatus === "needsInfo" ? true : false,
        id,
        correctionId,
        userId,
        selectedActionId,
        data?.notes,
        cultureCode,
        newPayload,
      );
      if (res?.data?.status === "Success") {
        setShowConfirmation(true);
        notifySuccess("Data correction action has been submitted successfully"); // Show success notification
      } else if (res?.data?.status === "Error") {
        notifyError(
          res?.data?.message ||
            "An error occurred while submitting the data correction action.",
        ); // Show error notification
      }
    } catch (err) {
      console.log("Error: ", err?.messsage);
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  const groupDiscussionData = (data = []) => {
    return data
      ?.sort(
        (a, b) =>
          a.correctionAction.displayOrder - b.correctionAction.displayOrder ||
          new Date(a.discussionDate) - new Date(b.discussionDate),
      )
      ?.reduce((acc, item) => {
        const dateKey = new Date(item.discussionDate).toLocaleDateString(
          "en-GB",
        );

        const time = new Date(item.discussionDate).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });

        if (!acc[dateKey]) {
          acc[dateKey] = [];
        }

        acc[dateKey].push({
          discussion: item.discussion,
          time,
          iconCss: item.correctionAction?.iconCss,
          userName: item.studyUser?.userName,
          displayOrder: item.correctionAction?.displayOrder,
        });

        return acc;
      }, {});
  };

  const getDiscussionIcon = (iconCss) => {
    switch (iconCss) {
      case "fa fa-info-circle":
        return <InfoOutlinedIcon color="info" />;

      case "fa fa-check-circle":
        return <CheckCircleIcon color="success" />;

      case "fa fa-check":
        return <DoneIcon color="success" />;

      case "fa fa-times":
        return <CancelIcon color="error" />;

      case "fa fa-times-circle":
        return <CancelIcon color="error" />;

      case "fa fa-edit":
        return <EditIcon color="primary" />;

      case "fa fa-comment":
        return <ChatBubbleOutlineIcon color="secondary" />;

      default:
        return <AccessTimeIcon color="secondary" />;
    }
  };

  return (
    <>
      {showConfirmation ? (
        <DataCorrectionConfirmation
          correctionData={correctionTableData}
          id={id}
          data={[]}
          setShowConfirm={setShowConfirmation}
          subjectName={subjectName}
          isRemovedSubject={isRemovedSubject}
          isFromDataCorrection={true}
        />
      ) : (
        <>
          {load ? (
            <Loader />
          ) : (
            <div className="content-body">
              <p className="bread-crumbs-link-container">
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(e, isDirty, "", navigate)
                  }
                >
                  Home
                </button>{" "}
                |{" "}
                <button
                  className="bread-crumbs-btn"
                  onClick={(e) =>
                    handleUnsaveNavigation(
                      e,
                      isDirty,
                      "data-corrections",
                      navigate,
                    )
                  }
                >
                  Data Correction
                </button>
                {" | "}
                <button className="bread-crumbs-btn">
                  Approve / Reject Correction
                </button>
                -{" "}
                <b style={{ color: "gray" }}>
                  {localStorage?.getItem("studyName")}
                </b>
              </p>
              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={12}>
                  <p className="page-heading">Approve / Deny Data Correction</p>
                </Grid2>
              </Grid2>

              <Box
                component="form"
                autoComplete="off"
                sx={{ height: "auto", width: "100%" }}
                onSubmit={handleSubmit(saveDataCorrectionAction)}
              >
                <Grid2
                  container
                  alignItems="center"
                  justifyContent={"center"}
                  sx={{ width: "100%", margin: "0 auto" }}
                  gap={5}
                >
                  <div>
                    <div className={style?.containerWrapper}>
                      <div className={style?.labelWrapper}>
                        <strong>Site Name:</strong>
                      </div>
                      <div className={style?.valueWrapper}>{siteName}</div>
                    </div>

                    <div
                      className={`${style?.containerWrapper} ${style?.marginTop}`}
                    >
                      <div className={style?.labelWrapper}>
                        <strong>Subject Name:</strong>
                      </div>
                      <div className={style?.valueWrapper}>{subjectName}</div>
                    </div>

                    <div
                      className={`${style?.containerWrapper} ${style?.marginTop}`}
                    >
                      <div className={style?.labelWrapper}>
                        <strong>Correction Created At:</strong>
                      </div>
                      <div className={style?.valueWrapper}>
                        {formatDateWithoutTimeTwo(correctionCreatedOn)}
                      </div>
                    </div>

                    <div
                      className={`${style?.containerWrapper} ${style?.marginTop}`}
                    >
                      <div className={style?.labelWrapper}>
                        <strong>Correction Created By:</strong>
                      </div>
                      <div className={style?.labelWrapper}>
                        {correctionCreatedBy}
                      </div>
                    </div>

                    <div
                      className={`${style?.containerWrapper} ${style?.marginTop}`}
                    >
                      <div className={style?.labelWrapper}>
                        <strong>Reason For Correction:</strong>
                      </div>
                      <div className={style?.labelWrapper}>
                        {reasonForCorrection}
                      </div>
                    </div>
                  </div>
                </Grid2>

                <Grid2
                  container
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{ width: "55vw", minWidth: "61vw", margin: "20px auto" }}
                >
                  <div
                    style={{
                      marginTop: "10px",
                      width: "100%",
                    }}
                  >
                    <DataCorrectionSubmitGrid
                      tableData={correctionTableData}
                      isSubjectRemoved={isRemovedSubject}
                    />
                  </div>
                </Grid2>

                {discussionData && Object.keys(discussionData).length > 0 && (
                  <Grid2
                    container
                    alignItems="stretch"
                    justifyContent="flex-start"
                    sx={{
                      width: "55vw",
                      minWidth: "61vw",
                      margin: "20px auto",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        maxHeight: "400px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        padding: "0px 10px",
                      }}
                    >
                      <h3>Conversation</h3>
                      {Object.keys(discussionData)?.map((date, index) => (
                        <div key={index}>
                          <div
                            style={{
                              background: "lightgrey",
                              width: "100%",
                              padding: "15px 10px",
                              marginBottom: "20px",
                              marginTop: "20px",
                            }}
                          >
                            {formatNormalDateIntoDateStr(date)}
                          </div>

                          {discussionData[date]?.map((item, index) => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "15px",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  {getDiscussionIcon(item.iconCss)}
                                  {item?.userName}
                                </div>
                                <div
                                  style={{
                                    fontSize: "small",
                                  }}
                                >
                                  {item?.discussion}
                                </div>
                              </div>
                              <div>{item?.time}</div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </Grid2>
                )}

                <Grid2
                  container
                  alignItems="stretch"
                  justifyContent="flex-start"
                  sx={{
                    width: "55vw",
                    minWidth: "61vw",
                    margin: "20px auto",
                  }}
                >
                  <div
                    style={{
                      marginTop: "10px",
                      width: "50%",
                    }}
                  >
                    <h4>Type of Correction Action: </h4>
                    <button
                      type="button"
                      disabled={isDisabled}
                      onClick={() => setSelectedStatus("approve")}
                      className={`${
                        isDisabled
                          ? "disabled-btn large"
                          : selectedStatus === "approve"
                            ? "create-btn large"
                            : "create-btn-outlined large"
                      } hover`}
                      style={{
                        margin: "20px 0px",
                      }}
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => setSelectedStatus("reject")}
                      type="button"
                      disabled={isDisabled}
                      className={`${
                        isDisabled
                          ? "disabled-btn large"
                          : selectedStatus === "reject"
                            ? "create-btn large"
                            : "create-btn-outlined large"
                      } hover`}
                      style={{
                        margin: "20px 0px",
                      }}
                    >
                      Reject
                    </button>
                    <button
                      type="button"
                      disabled={isDisabled}
                      onClick={() => setSelectedStatus("needsInfo")}
                      className={`${
                        isDisabled
                          ? "disabled-btn large"
                          : selectedStatus === "needsInfo"
                            ? "create-btn large"
                            : "create-btn-outlined large"
                      } hover`}
                      style={{
                        margin: "20px 0px",
                      }}
                    >
                      Needs more information
                    </button>
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      width: "50%",
                    }}
                  >
                    <h4>Notes</h4>
                    <TextField
                      {...register("notes")}
                      multiline
                      rows={5}
                      sx={{
                        width: "100%",
                      }}
                    />
                    {errors.notes && (
                      <div className="error-container">
                        {errors.notes.message}
                      </div>
                    )}
                  </div>
                </Grid2>

                <Grid2
                  alignItems={"end"}
                  justifyContent="end"
                  container
                  gap={3}
                  sx={{ marginTop: "2%" }}
                >
                  <Grid2 item md={6}>
                    <button
                      type="button"
                      className="create-btn-outlined"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "data-corrections",
                          navigate,
                        );
                      }}
                    >
                      Back
                    </button>
                  </Grid2>
                  <Grid2 item md={6}>
                    <button
                      type="submit"
                      className={
                        !selectedStatus ? "disabled-btn" : "create-btn"
                      }
                      disabled={!selectedStatus}
                    >
                      Submit
                    </button>
                  </Grid2>
                </Grid2>
              </Box>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ApproveRejectDataCorrections;
